import BaseDialog from './BaseDialog'

export default {
	props: {
		title: {
			type: String,
			default: 'Title'
		},
		yesLabel: {
			type: String,
			default: 'はい'
		},
		noLabel: {
			type: String,
			default: 'いいえ'
		}
	},

	components: {
		BaseDialog
	},

	template: `
		<BaseDialog :title="title">
			<slot />
			<template v-slot:buttons>
				<button type="button" class="bs-ed-btn bs-ed-btn-primary" @click="$emit('yes')">
					{{yesLabel}}
				</button><button type="button" class="bs-ed-btn bs-ed-btn-default" @click="$emit('no')">
					{{noLabel}}
				</button>
			</template>
		</BaseDialog>
	`
}
